import { Alert } from "@/components/common/Alert/Alert";
import { LoadingPage } from "@/components/common/Loading/LoadingPage";
import { MaintenanceSection, MaintenanceSectionContent, MaintenanceSectionHeader } from "@/components/layout/maintenance";
import { useAccountSettings } from "./hooks/useAccountSettings";
import { SignInMethodsCard } from "./components/SignInMethodsCard";
import { CalendarConnectionCard } from "./components/CalendarConnectionCard";
import { MailConnectionCard } from "./components/MailConnectionCard";
import { LicensingNotice } from "./components/LicensingNotice";

export const AccountSettingsPage = () => {
  const { settings, isLoading, loadError, refresh } = useAccountSettings();

  return (
    <MaintenanceSection>
      {/* Settings read as a form rather than a data grid, so the page is kept
          narrower than the full-width maintenance screens. */}
      <div className="max-w-4xl">
        <MaintenanceSectionHeader
          title="Account Settings"
          subtitle="Manage how you sign in and which Microsoft services are connected."
        />
        <MaintenanceSectionContent>
          {isLoading ? (
            <LoadingPage message="Loading your account..." />
          ) : loadError || !settings ? (
            <Alert variant="error" persistent>
              {loadError ?? "We couldn't load your account settings."}
            </Alert>
          ) : (
            <div className="grid gap-2 min-w-0">
              <SignInMethodsCard settings={settings} onChanged={refresh} />

              <CalendarConnectionCard connection={settings.calendar} onChanged={refresh} />

              <MailConnectionCard connection={settings.mail} onChanged={refresh} />

              <LicensingNotice />
            </div>
          )}
        </MaintenanceSectionContent>
      </div>
    </MaintenanceSection>
  );
};
